import {Endpoint} from '@eryxcoop/appyx-comm';

export default class EditCustomerOnboardingCommercialTermsEndpoint extends Endpoint {

    adaptValues({
                    taxpayerIdentificationNumber,
                    commercialTerms
                }) {
        return {
            taxpayer_identification_number: taxpayerIdentificationNumber,
            price_list_code: commercialTerms.priceList,
            payment_term_code: commercialTerms.paymentTerm,
            payment_method: commercialTerms.paymentMethod,
            customer_group_code: commercialTerms.customerGroup,
            segment: commercialTerms.segment,
            horeca_subcategory: commercialTerms.horecaSubcategory,
        }
    }
}